'use client'

import { useHintHydrationReadyForEndToEndTest } from './useHintHydrationReadyForEndToEndTest'

export const FrontendTestsHydrationHint = (): null => {
  useHintHydrationReadyForEndToEndTest()

  return null
}
